import {
  GET_AWS_MISSING_ALERTS_BY_RESOURCE_ID,
  GET_AWS_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
  GET_AWS_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
  GET_AWS_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID,
  GET_AWS_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_SUCCESS,
  GET_AWS_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_FAIL,
  GET_AWS_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID,
  GET_AWS_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_SUCCESS,
  GET_AWS_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_FAIL,
  DEPLOY_AWS_DYNAMIC_ALERTS_BY_RESOURCE_ID,
  DEPLOY_AWS_DYNAMIC_ALERTS_BY_RESOURCE_ID_SUCCESS,
  DEPLOY_AWS_DYNAMIC_ALERTS_BY_RESOURCE_ID_FAIL,
  GET_NR_MISSING_ALERTS_BY_RESOURCE_ID,
  GET_NR_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS,
  GET_NR_MISSING_ALERTS_BY_RESOURCE_ID_FAIL,
  GET_AWS_RESOURCE_BY_RESOURCE_ID,
  GET_AWS_RESOURCE_BY_RESOURCE_ID_SUCCESS,
  GET_AWS_RESOURCE_BY_RESOURCE_ID_FAIL,
  GET_DEFAULT_THRESHOLD_BY_RESOURCE_ID,
  GET_DEFAULT_THRESHOLD_BY_RESOURCE_ID_SUCCESS,
  GET_DEFAULT_THRESHOLD_BY_RESOURCE_ID_FAIL,
  POST_SERVICE_MAPPING_SUCCESS,
  POST_SERVICE_MAPPING_FAIL,
  POST_SERVICE_MAPPING,
  PUT_ALERTS_FAIL,
  PUT_ALERTS_SUCCESS,
  PUT_ALERTS,
  GET_ALERTS_FAIL,
  GET_ALERTS_SUCCESS,
  POST_ENABLE_ALERTS,
  POST_ENABLE_ALERTS_FAIL,
  POST_DISABLE_ALERTS,
  POST_DISABLE_ALERTS_FAIL, POST_ENABLE_ALERTS_SUCCESS, POST_DISABLE_ALERTS_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  resource_missing_alerts: [],
  resource_missing_dynamic_alerts: {},
  resource_dynamic_alerts_deployed: {},
  nr_resource_missing_alerts: [],
  aws_resource: {},
  default_threshold_aws_resource: [],
  alerts: [],
};

const Alert = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_AWS_MISSING_ALERTS_BY_RESOURCE_ID:
      return {
        ...state,
        error: action.payload,
      }

    case GET_AWS_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS:
      return {
        ...state,
        resource_missing_alerts: action.payload
      }

    case GET_AWS_MISSING_ALERTS_BY_RESOURCE_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_AWS_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID:
      return {
        ...state,
        error: action.payload,
      }

    case GET_AWS_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_SUCCESS:
      return {
        ...state,
        resource_missing_dynamic_alerts: action.payload
      }

    case GET_AWS_MISSING_DYNAMIC_ALERTS_BY_RESOURCE_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_AWS_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID:
      return {
        ...state,
        error: action.payload,
      }

    case GET_AWS_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_SUCCESS:
      return {
        ...state,
        resource_dynamic_alerts_deployed: action.payload
      }

    case GET_AWS_DYNAMIC_ALERTS_DEPLOYED_BY_RESOURCE_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case DEPLOY_AWS_DYNAMIC_ALERTS_BY_RESOURCE_ID:
      return {
        ...state,
        error: action.payload,
      }

    case DEPLOY_AWS_DYNAMIC_ALERTS_BY_RESOURCE_ID_SUCCESS:
      return {
        ...state,
        resource_dynamic_alerts_deployed: action.payload
      }

    case DEPLOY_AWS_DYNAMIC_ALERTS_BY_RESOURCE_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NR_MISSING_ALERTS_BY_RESOURCE_ID:
      return {
        ...state,
        error: action.payload,
      }

    case GET_NR_MISSING_ALERTS_BY_RESOURCE_ID_SUCCESS:
      return {
        ...state,
        nr_resource_missing_alerts: action.payload
      }

    case GET_NR_MISSING_ALERTS_BY_RESOURCE_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_AWS_RESOURCE_BY_RESOURCE_ID:
      return {
        ...state,
        error: action.payload,
      }

    case GET_AWS_RESOURCE_BY_RESOURCE_ID_SUCCESS:
      return {
        ...state,
        aws_resource: action.payload
      }

    case GET_AWS_RESOURCE_BY_RESOURCE_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case POST_SERVICE_MAPPING:
      return {
        ...state,
        error: action.payload,
      }

    case POST_SERVICE_MAPPING_SUCCESS:
      return {
        ...state,
        aws_resource: action.payload[0],
      }

    case POST_SERVICE_MAPPING_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_DEFAULT_THRESHOLD_BY_RESOURCE_ID:
      return {
        ...state,
        error: action.payload,
      }

    case GET_DEFAULT_THRESHOLD_BY_RESOURCE_ID_SUCCESS:
      return {
        ...state,
        default_threshold_aws_resource: action.payload
      }

    case GET_DEFAULT_THRESHOLD_BY_RESOURCE_ID_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case PUT_ALERTS:
      return {
        ...state,
        error: action.payload,
      }

    case PUT_ALERTS_SUCCESS:
      Object.keys(state.alerts).forEach(key => {
        state.alerts[key].forEach(alert => {
          if (alert.id === action.payload.id) {
            alert = action.payload
          }
        })
      })
      return {
        ...state,
        alerts: state.alerts
      }

    case PUT_ALERTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case GET_ALERTS_SUCCESS:
      return {
        ...state,
        alerts: action.payload,
      }

    case GET_ALERTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case POST_ENABLE_ALERTS:
      return {
        ...state,
        alerts: action.payload,
      }

    case POST_ENABLE_ALERTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case POST_ENABLE_ALERTS_SUCCESS:
      return {
        ...state,
        alerts: action.payload,
      }

    case POST_DISABLE_ALERTS:
      return {
        ...state,
        error: action.payload,
      }

    case POST_DISABLE_ALERTS_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case POST_DISABLE_ALERTS_SUCCESS:
      return {
        ...state,
        alerts: action.payload,
      }

    default:
      return state
  }
}

export default Alert;
